import React, { useContext, forwardRef, createContext } from 'react';
const AccordionItemContext = createContext(undefined);
const AccordionItem = forwardRef(function AccordionItem({ testId = 'store-accordion-item', children, prefixId = '', index = 0, as: MaybeComponent, ...otherProps }, ref) {
    const Component = MaybeComponent ?? 'div';
    const context = {
        index,
        prefixId,
        panel: `${prefixId && `${prefixId}-`}panel--${index}`,
        button: `${prefixId && `${prefixId}-`}button--${index}`,
    };
    return (React.createElement(AccordionItemContext.Provider, { value: context },
        React.createElement(Component, Object.assign({ ref: ref, "data-accordion-item": true, "data-testid": testId }, otherProps), children)));
});
export function useAccordionItem() {
    const context = useContext(AccordionItemContext);
    if (context === undefined) {
        throw new Error('Do not use AccordionItem components outside the AccordionItem context.');
    }
    return context;
}
/**
 * This is only being exported to make it easier to use in Storybook.
 * **DON'T** import this directly to use this component, use the default export
 * instead.
 */
export const StorybookAccordionItem = AccordionItem;
export default AccordionItem;
//# sourceMappingURL=AccordionItem.js.map